import { graphql } from "@server/gql";

export default graphql(/* GraphQL */ `
  query BrandPageBySlug(
    $locale: String!
    $slug: String!
    $limit: Int!
    $textBlockName: String!
    $preview: Boolean
    $activeMarkets: [String]
  ) {
    siteinfoCollection(locale: $locale, limit: 1) {
      items {
        ...brandPageSiteinfo
      }
    }
    pageCollection(
      locale: $locale
      where: { slug: $slug }
      limit: $limit
      preview: $preview
    ) {
      items {
        ...brandPage
      }
    }
    textBlockCollection(
      locale: $locale
      where: { name: $textBlockName }
      limit: 1
    ) {
      items {
        ...textBlock
      }
    }
  }
`);
